export enum RoleEnum {
  SUPER_ADMIN = '00001',
  ADMIN = '00002',
}

export enum LoginTypeEnum {
  STANDARD = 'STANDARD',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
}

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  AUDIO = 'AUDIO',
  FILE = 'FILE',
  EMOTION = 'EMOTION',
  LOCATION = 'LOCATION',
}
